import sdk from '@adc/sdk'
import moment from 'moment'

export type AuditUtilOptions = {
  exhaustive: boolean
  up_until_date: moment.Moment | undefined
}

export type AuditSearchResult = {
  [key: string]: {
    added: AuditSearchResultItem | undefined
    modified: AuditSearchResultItem | undefined
    removed: AuditSearchResultItem | undefined
  }
}

export type AuditSearchResultItem = {
  updated_date: moment.Moment | undefined
  value: any
}

export function getLatestUpdatesFromHistoryCollectionResultsForFields(
  fields: string[] = [],
  historyEntries: sdk.G.AuditHistoryCollectionResult[] = [],
  options: AuditUtilOptions = { exhaustive: false, up_until_date: undefined }
) {
  const entries = (historyEntries || [])
    .map(h => h.histories)
    .reduce((acc = [], histories = []) => acc?.concat(histories))
  return getLatestUpdatesFromHistoryEntriesForFields(
    fields,
    entries == null ? [] : entries,
    options
  )
}

export function getLatestUpdatesFromHistoryEntriesForFields(
  fields: string[] = [],
  historyEntries: sdk.G.Maybe<sdk.G.AuditHistoryEntry>[] = [],
  options: AuditUtilOptions = { exhaustive: false, up_until_date: undefined }
) {
  let result: AuditSearchResult = {}
  fields.forEach(field => {
    result[field] = {
      added: undefined,
      modified: undefined,
      removed: undefined,
    }
    for (let i = 0; i < historyEntries.length; i++) {
      const log = historyEntries?.[i]
      const entry: sdk.G.AuditHistoryDelta = log?.delta!

      if (
        options?.up_until_date !== undefined &&
        !!log!.updated_date &&
        moment(log!.updated_date).isBefore(moment(options?.up_until_date))
      ) {
        break
      }

      const addedValue = (entry.added as any)[field]
      if (!result[field].added && addedValue !== undefined) {
        result[field].added = {
          updated_date: moment(log!.updated_date),
          value: addedValue,
        }
      }

      const modifiedValue = (entry?.modified as any)[field]
      if (!result[field].modified && modifiedValue !== undefined) {
        result[field].modified = {
          updated_date: moment(log!.updated_date),
          value: modifiedValue,
        }
      }

      if (!result[field].removed && entry?.removed?.includes(field)) {
        result[field].removed = {
          updated_date: moment(log!.updated_date),
          value: undefined,
        }
      }

      if (options?.exhaustive) {
        if (
          Object.keys(result?.[field]?.added || {}).length > 0 &&
          Object.keys(result?.[field]?.modified || {}).length > 0 &&
          Object.keys(result?.[field]?.removed || {}).length > 0
        ) {
          break
        }
      } else {
        if (
          Object.keys(result?.[field]?.added || {}).length > 0 ||
          Object.keys(result?.[field]?.modified || {}).length > 0 ||
          Object.keys(result?.[field]?.removed || {}).length > 0
        ) {
          break
        }
      }
    }
  })
  return result
}
